webpackJsonp([156897593687669],{

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _underConstruction = __webpack_require__(70);
	
	var _underConstruction2 = _interopRequireDefault(_underConstruction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resume = function Resume() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Resume'
	    ),
	    _react2.default.createElement('img', { style: { height: '100%', width: '100%' }, src: _underConstruction2.default })
	  );
	};
	
	exports.default = Resume;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-resume-js-aa6688c722541d43c6f3.js